function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import Icon from "./Icon";
/* eslint-disable max-len */

var IncreaseIcon = function IncreaseIcon(_ref) {
  var color = _ref.color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return React.createElement(Icon, _extends({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22"
  }, props, {
    fill: "none"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1499 10.9999C4.1499 10.5305 4.53046 10.1499 4.9999 10.1499H17.4999C17.9693 10.1499 18.3499 10.5305 18.3499 10.9999C18.3499 11.4693 17.9693 11.8499 17.4999 11.8499H4.9999C4.53046 11.8499 4.1499 11.4693 4.1499 10.9999Z",
    fill: color
  }));
};

export default IncreaseIcon;